import React from 'react'

const PrivacyPage = () => {
  return (
    <div className='md:pt-[140px] pt-[100px] md:px-[100px] px-4'>
      <h2 className="md:text-3xl text-xl font-bold md:mb-6 mb-2">
        Privacy Policy for Rehovot resources inc
      </h2>
      <p className="text-sm">
        At Rehovot resources inc, accessible from info@rehovotresourcesinc.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Rehovot resources inc and how we use it. 
        <br /><br />
        If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us. 
        <br /><br />
        <span className="font-bold">General Data Protection Regulation (GDPR)</span>
        <br />
        We are a Data Controller of your information. 
        <br /><br />
        Rehovot resources inc legal basis for collecting and using the personal information described in this Privacy Policy depends on the Personal Information we collect and the specific context in which we collect the information: 
        <br /><br />
        Rehovot resources inc needs to perform a contract with you 
        <br />
        You have given Rehovot resources inc permission to do so 
        <br />
        Processing your personal information is in Rehovot resources inc legitimate interests 
        <br />
        Rehovot resources inc needs to comply with the law 
        <br />
        Rehovot resources inc will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your information to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our policies. 
        <br /><br />
        If you are a resident of the European Economic Area (EEA), you have certain data protection rights. If you wish to be informed what Personal Information we hold about you and if you want it to be removed from our systems, please contact us. 
        <br /><br />
        In certain circumstances, you have the following data protection rights: 
        <br /><br />
        The right to access, update or to delete the information we have on you. 
        <br />
        The right of rectification. 
        <br />
        The right to object. 
        <br />
        The right of restriction. 
        <br />
        The right to data portability 
        <br />
        The right to withdraw consent 
        <br />
        Log Files 
        <br />
        Rehovot resources inc follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information. 
        <br /><br />
        Cookies and Web Beacons 
        <br />
        Like any other website, Rehovot resources inc uses "cookies". These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information. 
        <br /><br />
        Google DoubleClick DART Cookie 
        <br />
        Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – https://policies.google.com/technologies/ads 
        <br /><br />
        Our Advertising Partners 
        <br />
        Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below. 
        <br /><br />
        Google 
        <br /><br />
        https://policies.google.com/technologies/ads 
        <br /><br />
        Privacy Policies 
        <br />
        You may consult this list to find the Privacy Policy for each of the advertising partners of Rehovot resources inc. 
        <br /><br />
        Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Rehovot resources inc, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit. 
        <br /><br />
        Note that Rehovot resources inc has no access to or control over these cookies that are used by third-party advertisers. 
        <br /><br />
        Third Party Privacy Policies 
        <br />
        Rehovot resources inc's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. 
        <br /><br />
        You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites. 
        <br /><br />
        Children's Information 
        <br />
        Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity. 
        <br /><br />
        Rehovot resources inc does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records. 
        <br /><br />
        Online Privacy Policy 
        <br />
        Only Our Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Rehovot resources inc. This policy is not applicable to any information collected offline or via channels other than this website. 
        <br /><br />
        Consent 
        <br />By using our website, you hereby consent to our Privacy Policy and agree to its terms.
      </p>
    </div>
  )
}

export default PrivacyPage